var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-patrol-full"}},[_c('b-card',{attrs:{"no-body":""}}),_vm._l((_vm.dataDashboard),function(item){return _c('div',{key:item.id},[_c('dashboardProgressCircleFull',{attrs:{"data":item,"idModal":item.id}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }